export const getConfig = (state, config) => {
  state.config = config
}

export const setLoading = (state, value) => {
  state.loading = value;
}